import { Controller } from "@hotwired/stimulus"
import { DateRangePicker } from "flowbite-datepicker"

export default class extends Controller {
  static values = {
    autohide: { type: Boolean, default: true },
    format: { type: String, default: "yyyy-mm-dd" },
    minDate: String,
    maxDate: String,
  }

  connect() {
    const options = {
      autohide: this.autohideValue,
      format: this.formatValue,
      minDate: this.minDateValue,
      maxDate: this.maxDateValue,
    }

    this.rangepicker = new DateRangePicker(this.element, options)
  }

  disconnect() {
    if (this.rangepicker) {
      this.rangepicker.destroy()
      this.rangepicker = null
    }
  }
}
